import React from 'react';
import { Crown } from 'lucide-react';
import { motion } from 'framer-motion';
export function CrownDivider() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="flex items-center justify-center w-full py-12 opacity-50" data-id="element-71">
      <div className="h-[1px] w-24 bg-gradient-to-r from-transparent to-gold/50" data-id="element-72"></div>
      <Crown className="mx-4 text-gold" size={24} data-id="element-73" />
      <div className="h-[1px] w-24 bg-gradient-to-l from-transparent to-gold/50" data-id="element-74"></div>
    </motion.div>;
}